import React from 'react';
import ReactSelect from 'react-select';
import { Search } from 'lucide-react';

const defaultStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  control: (provided, state) => ({
    ...provided,
    borderRadius: '0.75rem',
    borderWidth: '1px',
    borderColor: state.isFocused ? 'hsl(var(--primary))' : 'hsl(var(--border))',
    boxShadow: state.isFocused ? '0 0 0 1px hsl(var(--primary))' : 'none',
    backgroundColor: '#ffffff',
    paddingTop: '10px',
    paddingBottom: '9px',
    paddingLeft: '2.5rem',
    fontSize: '1rem'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'hsl(var(--muted-foreground))',
    fontSize: '1rem'
  }),
  input: (provided) => ({
    ...provided,
    fontSize: '1rem',
    color: 'hsl(var(--foreground))'
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '0.75rem',
    overflow: 'hidden',
    boxShadow:
      '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#f1f5f9' : 'white',
    color: state.isFocused ? '#1e293b' : '#64748b',
    cursor: 'pointer',
    padding: '12px 16px',
    fontSize: '1rem'
  })
};

const SearchSelect = ({
  className = 'w-72',
  options = [],
  value = null,
  onChange,
  placeholder = 'Search',
  styles = {},
  ...rest
}) => {
  const mergedStyles = { ...defaultStyles, ...styles };

  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground z-10" />
      <ReactSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={mergedStyles}
        classNamePrefix="react-select"
        {...rest}
      />
    </div>
  );
};

export default SearchSelect;
